import React from 'react'
import clsx from 'clsx'
import { makeStyles, createStyles, Theme } from '@material-ui/core'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginTop: theme.spacing(0.25),
      textAlign: 'left',
    },
    /** Aligné sur `ProductPriceFormat` (`classes.promotion`) pour les cartes produit */
    inlineRoot: {
      display: 'inline-flex',
      alignItems: 'center',
      marginLeft: theme.spacing(1),
    },
    badge: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText,
      borderRadius: theme.spacing(0.5),
      fontSize: '75%',
      padding: theme.spacing(0, 0.5),
      display: 'inline-block',
      whiteSpace: 'nowrap',
    },
  })
)

export type TaxonPromotionBadgeProps = {
  percent?: number | null
  /** Prix sur une même ligne (ex. carte produit) au lieu du bloc sous le titre panier */
  inline?: boolean
  /** Si `false`, le composant ne rend rien */
  display?: boolean
}

const TaxonPromotionBadge = ({
  percent,
  inline = false,
  display = true,
}: TaxonPromotionBadgeProps) => {
  const classes = useStyles()

  if (!display || percent == null) return null

  const badge = (
    <span
      className={clsx(
        inline ? 'productCard__discount' : 'cart-item__discount',
        classes.badge
      )}
    >
      -{percent}&nbsp;%
    </span>
  )

  if (inline) {
    return <span className={classes.inlineRoot}>{badge}</span>
  }

  return (
    <div className={clsx('cart-item__promo-badge', classes.root)}>{badge}</div>
  )
}

export default TaxonPromotionBadge
